import { GetterTree } from 'vuex';
import { State } from '@/stores/reports/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public allReports = (state: State) => state.allReports;
    public allReportsPage = (state: State) => state.allReportsPageNumber;
    public allReportsPageSize = (state: State) => state.allReportsPageSize;
    public allReportsTotalPages = (state: State) => state.allReportsTotalPages;
    public allReportsTotal = (state: State) => state.allReportsTotal;
    public allReportsFilterStatus = (state: State) => state.allReportsFilterStatus;
    public allReportsFrom = (state: State) => state.allReportsFrom;
    public allReportsTo = (state: State) => state.allReportsTo;
    public allReportOperators = (state: State) => state.allReportOperators;
    public allReportBooleanValues = (state: State) => state.allReportBooleanValues;
    public allReportLogicalOperators = (state: State) => state.allReportLogicalOperators;
}
